export const linkData=[
    {
        id:1,
        title:'Telegram Link',
        referenceCode:'facebook_ads',
        redirectLink:'https://mangocash.in/app',
        dateTime:'23 Nov 2025 01:05 PM',
        isActive:true
    },
    {
        id:2,
        title:'Instagram Link',
        referenceCode:'facebook_ads',
        redirectLink:'https://mangocash.in/app',
        dateTime:'23 Nov 2025 01:05 PM',
        isActive:true
    },
    {
        id:3,
        title:'Telegram Link',
        referenceCode:'facebook_ads',
        redirectLink:'https://mangocash.in/app',
        dateTime:'23 Nov 2025 01:05 PM',
        isActive:true
    },
    {
        id:4,
        title:'Instagram Link',
        referenceCode:'facebook_ads',
        redirectLink:'https://mangocash.in/app',
        dateTime:'23 Nov 2025 01:05 PM',
        isActive:true
    },
];